import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[uniconNumberFormatter]',
})
export class NumberFormatterDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let inputValue = inputElement.value;
    inputValue = inputValue.replace(/[^0-9]/g, '');
    inputElement.value = inputValue;
    inputElement.dispatchEvent(new Event('input'));
  }
}
